import { isUserUsingMobile } from "@commercekit/shared";
import type { FC } from "react";
import { useEffect, useRef, useState } from "react";
import { withPosterFragment } from "~/lib/productSlides";
import PlayIcon from "../icons/PlayIcon";

async function requestVideoFullscreen(video: HTMLVideoElement): Promise<void> {
  if (typeof document !== "undefined" && document.fullscreenElement === video) {
    return;
  }

  const extended = video as HTMLVideoElement & {
    webkitEnterFullscreen?: () => void;
    msRequestFullscreen?: () => void;
  };

  if (typeof extended.webkitEnterFullscreen === "function") {
    extended.webkitEnterFullscreen();
    return;
  }

  if (typeof video.requestFullscreen === "function") {
    await video.requestFullscreen();
    return;
  }

  if (typeof extended.msRequestFullscreen === "function") {
    extended.msRequestFullscreen();
  }
}

const WvFileCarouselPlayer: FC<{
  src: string;
  title: string;
  active: boolean;
}> = ({ src, title, active }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [loaded, setLoaded] = useState(active);

  useEffect(() => {
    if (active) setLoaded(true);
    // Don't keep playing once swiped away.
    else videoRef.current?.pause();
  }, [active]);

  if (!loaded) {
    return (
      <>
        <video
          className="product-carousel__video object-cover"
          preload="metadata"
          muted
          playsInline
          tabIndex={-1}
          aria-hidden
          src={withPosterFragment(src)}
        />
        <PlayIcon />
      </>
    );
  }

  return (
    <video
      ref={videoRef}
      className="product-carousel__video"
      controls
      playsInline
      preload="metadata"
      src={withPosterFragment(src)}
      title={title}
      onPlay={(event) => {
        if (!isUserUsingMobile(true)) return;
        requestVideoFullscreen(event.currentTarget).catch(() => {});
      }}
      onClick={(event) => event.stopPropagation()}
    />
  );
};

export default WvFileCarouselPlayer;
